import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { PainPoints } from './components/PainPoints';
import { SolutionReveal } from './components/SolutionReveal';
import { TomosSection } from './components/TomosSection';
import { BonusSection } from './components/BonusSection';
import { PricingSection } from './components/PricingSection';
import { ExtendedTestimonials } from './components/ExtendedTestimonials';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { PurchaseNotifications } from './components/PurchaseNotifications';
declare global {
  interface Window {
    fbq?: ((event: string, ...args: unknown[]) => void) & {
      queue?: unknown[][];
      loaded?: boolean;
      version?: string;
      callMethod?: (...args: unknown[]) => void;
    };
    _fbq?: unknown;
  }
}
const META_PIXEL_ID = '1041610391949857';
export function App() {
  useEffect(() => {
    try {
      if (!window.fbq) {
        const pixel = function (...args: unknown[]) {
          pixel.callMethod ? pixel.callMethod(...args) : pixel.queue?.push(args);
        } as NonNullable<Window['fbq']>;
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch {
      /* Analytics must not affect the storefront. */
    }
  }, []);
  return <div className="min-h-screen w-full bg-cream text-ink selection:bg-gold/20" data-id="element-0" data-mp="nuhjilyq8hvv">
      <main data-id="element-1" data-mp="stuexv3nyxa2">
        <Hero data-id="element-2" data-mp="stkok6epio3u" />
        <TestimonialsStrip data-id="element-3" data-mp="st2iyj65mxj9" />
        <PainPoints data-id="element-4" data-mp="swgmhuqk1csa" />
        <SolutionReveal data-id="element-5" data-mp="3686fj9n0kvj" />
        <TomosSection data-id="element-6" data-mp="35gmj5pekbl3" />
        <BonusSection data-id="element-7" data-mp="34x4lozr5n72" />
        <PricingSection data-id="element-8" data-mp="38b6yx8f1wei" />
        <ExtendedTestimonials data-id="element-9" data-mp="3udawu8hnin4p" />
        <Guarantee data-id="element-10" data-mp="3ubzumd3utnfp" />
        <FAQ data-id="element-11" data-mp="3ucjehzd2elwd" />
        <FinalCTA data-id="element-12" data-mp="3uf5i5nwu4h9b" />
      </main>
      <Footer data-id="element-13" data-mp="d57ep0qhqei0" />
      <PurchaseNotifications data-id="element-14" data-mp="d3mkxdc02zl7" />
      <img src="https://www.facebook.com/tr?id=1041610391949857&ev=PageView&noscript=1" alt="" aria-hidden="true" width={1} height={1} className="hidden" data-id="element-15" data-mp="d3wbp34vdary" />
    </div>;
}